import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, useRouteMatch } from 'react-router-dom';
import { Switch } from 'react-router';

import { RootState } from '../../models/RootState';
import { fetchButtonVariables } from '../../store';
import ExchSportsView from './ExchangeSportsView';
import ExchangeSportsListNav from '../../components/ExchSportsListNav/ExchangeSportsListNav';
import ExchInplayEventsView from '../ExchInplayEvents/ExchInplayEventsView';
import ExchangeAllMarkets from './ExchangeAllMarkets';
import ExchBinaryView from '../ExchBinaryView/ExchBinaryView';
import ExchOutrightsView from '../ExchOutrightsView/ExchOutrightsView';
import {
  isConnected,
  connectToWS,
  disconnectToWS,
} from '../../webSocket/webSocket';
import './ExchangeSportsHomeView.scss';

type StoreProps = {
  loggedIn: boolean;
  topicUrls: any;
  fetchButtonVariables: () => void;
  betFairWSConnected: boolean;
};

const ExchangeSportsBook: React.FC<StoreProps> = (props) => {
  const { loggedIn, fetchButtonVariables, topicUrls, betFairWSConnected } = props;
  const { path } = useRouteMatch();

  useEffect(() => {
    if (loggedIn) {
      fetchButtonVariables();
    }
  }, [loggedIn]);

  // Websocket handler
  useEffect(() => {
    if (loggedIn && topicUrls?.matchOddsBaseUrl) {
      if (betFairWSConnected) {
        disconnectToWS();
      }
      const baseUrlsPayload = {
        matchOddsBaseUrl: topicUrls?.matchOddsBaseUrl,
        bookMakerAndFancyBaseUrl: topicUrls?.bookMakerBaseUrl,
        premiumBaseUrl: topicUrls?.premiumBaseUrl,
      };
      connectToWS(baseUrlsPayload);

      return () => {
        if (betFairWSConnected) {
          disconnectToWS();
        }
      };
    }
  }, [loggedIn, topicUrls]);

  return (
    <>
      <div className="ds-view-ctn">
        <div className="punter-view" id="main-content">
          <div className="sports-view-header">
            <ExchangeSportsListNav />
          </div>

          <div className="sports-view-ctn">
            <Switch>
              <Route exact path={path}>
                <ExchSportsView />
              </Route>
              <Route
                exact
                path={`${path}/inplay`}
                render={() => <ExchInplayEventsView loggedIn={loggedIn} />}
              ></Route>
              <Route
                exact
                path={`${path}/binary`}
                render={() => <ExchBinaryView loggedIn={loggedIn} />}
              ></Route>
              <Route
                exact
                path={`${path}/:eventType`}
                render={() => <ExchSportsView />}
              />
              <Route
                exact
                path={`${path}/:eventType/:competition`}
                render={() => <ExchSportsView />}
              />
              <Route
                exact
                path={`${path}/:eventType/:competition/:eventId/:eventInfo`}
                render={() => <ExchangeAllMarkets loggedIn={loggedIn} />}
              />
            </Switch>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    topicUrls: state?.exchangeSports?.topicUrls,
    betFairWSConnected: state.exchangeSports.betFairWSConnected,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchButtonVariables: () => dispatch(fetchButtonVariables()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeSportsBook);
